// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1YVpe","search":"Settings_search__2SL8J","filter":"Settings_filter__1FjHu"};